import { usePropertyExitPlans } from '../../../../queries/PropertyFields/NonRentalLandFields';
import { MultilineTextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface ExitPlansProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const ExitPlans: React.FC<ExitPlansProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Please provide detail on exit plans';
    const [exitPlans, set_exitPlans] = usePropertyExitPlans(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={exitPlans}
                />
            ) : (
                <MultilineTextBox
                    id='exitPlans'
                    value={exitPlans}
                    onChange={set_exitPlans}
                    label={label}
                    required={required}
                />
            )}
        </>
    );
};
